import { Spinner } from './Spinner.tsx';
import { LAYOUT_CLASSES } from '../common/layout-styles.ts';
import type { CenteredSpinnerProps } from '@federa/types/ui-spinner';

/** A Spinner in a flex centering container, with optional padding, full-screen mode (min-h-screen) and all Spinner display props. */
export function CenteredSpinner({
	size = 'lg',
	variant = 'primary',
	label,
	showLabel = false,
	padding,
	fullScreen = false,
	backgroundColor,
	className,
}: CenteredSpinnerProps) {
	const baseClass = fullScreen ? `${LAYOUT_CLASSES.centerAll} min-h-screen` : LAYOUT_CLASSES.centerAll;
	const containerClass = className ? `${baseClass} ${className}` : baseClass;

	const hasStyle = padding !== undefined || backgroundColor !== undefined;
	const style = hasStyle
		? {
				...(padding !== undefined && { padding }),
				...(backgroundColor !== undefined && { backgroundColor }),
			}
		: undefined;

	return (
		<div className={containerClass} style={style}>
			<Spinner size={size} variant={variant} label={label} showLabel={showLabel} />
		</div>
	);
}
